import React, { FunctionComponent, ReactNode } from 'react'
import { Portal } from '@afterpaytouch/core'
import styles from './style.module.css'
import clsx from 'clsx'

export type OverlayType = 'none' | 'dark' | 'light' | 'darkSolid' | 'lightSolid'

interface DisabledModalProps {
  overlay?: OverlayType
  children?: ReactNode
}

const overlayClassMap: Record<OverlayType, string | undefined> = {
  none: undefined,
  dark: styles.darkOverlay,
  light: styles.lightOverlay,
  darkSolid: styles.darkSolid,
  lightSolid: styles.lightSolid,
}

export const DisabledModal: FunctionComponent<DisabledModalProps> = ({ children, overlay = 'none' }) => {
  const className = clsx(styles.container, overlayClassMap[overlay])
  return (
    <Portal>
      <div className={className} />
      {children}
    </Portal>
  )
}
